<template>
    <div>
        <div class="container">
        
        <div class="p-3 mb-2 bg-primary text-white">{{ date }}</div>
        <hr>
        <div class="card" v-for="sign in signs" v-bind:key="sign.rank">
            <div class="card-header">
                第{{ sign.rank }}位
            </div>
            <div class="card-body">
                <div class="card-title">
                    <img v-bind:src="'/images/' + sign.image" class="img-thumbnail" width="40px" height="40px" />
                    {{ sign.sign }}
                </div>
                <div class="card-text mb-2">
                    {{ sign.content }}
                </div>
                <ul class="list-group">
                    <li class="list-group-item d-flex">{{ card_title[0] }}：{{ sign.money }}</li>
                    <li class="list-group-item d-flex">{{ card_title[1] }}：{{ sign.job }}</li>
                    <li class="list-group-item d-flex">{{ card_title[2] }}：{{ sign.love }}</li>
                    <li class="list-group-item d-flex">{{ card_title[3] }}：{{ sign.total }}</li>
                    <li class="list-group-item d-flex">{{ card_title[4] }}：{{ sign.item }}</li>
                    <li class="list-group-item d-flex">{{ card_title[5] }}：{{ sign.color }}</li>
                </ul>
            </div>
        </div>

        <p class="text-end">powerd by <a href="https://jugemkey.jp/api/waf/">JugemKey</a></p>
        <p class="text-end">【PR】<a href="http://www.tarim.co.jp/">原宿占い館 塔里木</a></p>

        </div>
    </div>
</template>

<script>

export default {
  name: "Home",
  data() {
    return {
      date : "",
      card_title : [
          '金運　　　　　　',
          '仕事運　　　　　',
          '恋愛運　　　　　',
          '総合運　　　　　',
          'ラッキーアイテム',
          'ラッキーカラー　'
        ],
      signs : []
    };
  },
  mounted: function() {
    this.$nextTick(function(){
      let date = new Date();
      let params = {
        'year'  : date.getFullYear(),
        'month' : date.getMonth() + 1,
        'day'   : date.getDate()
      }

      this.axios.get('/api/horoscope', { 'params' : params })
        .then((response) => {
          const res = response.data
          this.apiresponse = res;

          this.date = res.date;
          this.signs = res.signs;
        })
        .catch((e) => {
          alert(e);
        });
      })
  }

};
</script>
